module.exports = __webpack_public_path__ + "media/images/anoreglogo-565014f890c416913e195e037cc44e29.png";